/* Automatically generated file, do not update manually */
import type { Provider } from '@ethersproject/abstract-provider';
import { Contract, Signer } from 'ethers';
import { useMemo } from 'react';

import abi from 'libs/contracts/generated/infos/abis/ZyFiVault.json';
import { ZyFiVault } from 'libs/contracts/generated/infos/contractTypes';
import { getUniqueContractAddress } from 'libs/contracts/utilities/getUniqueContractAddress';
import { useChainId, useProvider, useSigner } from 'libs/wallet';
import { ChainId } from 'types';

interface GetZyFiVaultContractAddressInput {
  chainId: ChainId;
}

export const getZyFiVaultContractAddress = ({ chainId }: GetZyFiVaultContractAddressInput) =>
  getUniqueContractAddress({ name: 'ZyFiVault', chainId });

export const useGetZyFiVaultContractAddress = () => {
  const { chainId } = useChainId();

  return useMemo(
    () =>
      getZyFiVaultContractAddress({
        chainId,
      }),
    [chainId],
  );
};

interface GetZyFiVaultContractInput {
  chainId: ChainId;
  signerOrProvider: Signer | Provider;
}

export const getZyFiVaultContract = ({ chainId, signerOrProvider }: GetZyFiVaultContractInput) => {
  const address = getZyFiVaultContractAddress({ chainId });
  return address ? (new Contract(address, abi, signerOrProvider) as ZyFiVault) : undefined;
};

interface UseGetZyFiVaultContractInput {
  passSigner?: boolean;
  chainId?: ChainId;
}

export const useGetZyFiVaultContract = (input?: UseGetZyFiVaultContractInput) => {
  const { chainId: currentChainId } = useChainId();
  const chainId = input?.chainId || currentChainId;

  const { provider } = useProvider({ chainId });
  const { signer } = useSigner({ chainId });
  const signerOrProvider = input?.passSigner ? signer : provider;

  return useMemo(
    () =>
      signerOrProvider
        ? getZyFiVaultContract({
            chainId,
            signerOrProvider,
          })
        : undefined,
    [signerOrProvider, chainId],
  );
};
